<template>
    <div class="exhibition-add-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/expoList' }">
                    <i class="el-icon-s-promotion"></i>展会列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑展会' : '新增展会' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-circle-plus-outline"></i>
                    <span>{{ isEdit ? '编辑展会' : '新增展会' }}</span>
                </div>
                <div class="header-actions">
                    <el-button size="mini" icon="el-icon-back" @click="goBack">返回</el-button>
                </div>
            </div>

            <!-- 表单内容 -->
            <div class="form-container">
                <el-form
                        ref="exhibitionForm"
                        :model="form"
                        :rules="rules"
                        label-width="120px"
                        size="mini"
                        :disabled="loading"
                >
                    <!-- 基本信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-info"></i>
                            </div>
                            <div class="section-title">基本信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="展会名称" prop="title">
                                    <el-input
                                            v-model="form.title"
                                            placeholder="请输入展会名称"
                                            maxlength="50"
                                            show-word-limit
                                            prefix-icon="el-icon-edit"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="展会分类" prop="category_id">
                                    <el-select
                                            v-model="form.category_id"
                                            placeholder="请选择展会分类"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                    >
                                        <el-option
                                                v-for="item in categoryList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="展会状态" prop="status">
                                    <el-radio-group v-model="form.status">
                                        <el-radio :label="0">未开始</el-radio>
                                        <el-radio :label="1">进行中</el-radio>
                                        <el-radio :label="2">已结束</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="展会规模" prop="scale">
                                    <el-select
                                            v-model="form.scale"
                                            placeholder="请选择展会规模"
                                            style="width: 100%"
                                    >
                                        <el-option label="小型展会" value="small"></el-option>
                                        <el-option label="中型展会" value="medium"></el-option>
                                        <el-option label="大型展会" value="large"></el-option>
                                        <el-option label="特大型展会" value="xlarge"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="展会描述" prop="description">
                                    <el-input
                                            v-model="form.description"
                                            type="textarea"
                                            :rows="4"
                                            placeholder="请输入展会描述"
                                            maxlength="500"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 时间信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-time"></i>
                            </div>
                            <div class="section-title">时间信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="开始时间" prop="start_time">
                                    <el-date-picker
                                            v-model="form.start_time"
                                            type="datetime"
                                            placeholder="选择开始时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                            :picker-options="startDatePickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="结束时间" prop="end_time">
                                    <el-date-picker
                                            v-model="form.end_time"
                                            type="datetime"
                                            placeholder="选择结束时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                            :picker-options="endDatePickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="布展开始时间" prop="setup_start_time">
                                    <el-date-picker
                                            v-model="form.setup_start_time"
                                            type="datetime"
                                            placeholder="选择布展开始时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="撤展结束时间" prop="teardown_end_time">
                                    <el-date-picker
                                            v-model="form.teardown_end_time"
                                            type="datetime"
                                            placeholder="选择撤展结束时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 展馆信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-office-building"></i>
                            </div>
                            <div class="section-title">展馆信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="所属展馆" prop="venue_id">
                                    <el-select
                                            v-model="form.venue_id"
                                            placeholder="请选择展馆"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                            @change="handleVenueChange"
                                    >
                                        <el-option
                                                v-for="item in venueList"
                                                :key="item.id"
                                                :label="item.title"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预计观众数" prop="expected_visitors">
                                    <el-input-number
                                            v-model="form.expected_visitors"
                                            :min="0"
                                            :max="1000000"
                                            placeholder="预计观众数量"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="展会地址" prop="address">
                                    <el-input
                                            v-model="form.address"
                                            placeholder="请输入展会详细地址"
                                            prefix-icon="el-icon-location"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 展位信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-s-shop"></i>
                            </div>
                            <div class="section-title">展位信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="8">
                                <el-form-item label="总展位数" prop="total_booths">
                                    <el-input-number
                                            v-model="form.total_booths"
                                            :min="0"
                                            :max="10000"
                                            placeholder="总展位数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="标准展位价" prop="standard_price">
                                    <el-input
                                            v-model="form.standard_price"
                                            placeholder="标准展位价格"
                                            type="number"
                                            min="0"
                                    >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="特装展位价" prop="custom_price">
                                    <el-input
                                            v-model="form.custom_price"
                                            placeholder="特装展位价格"
                                            type="number"
                                            min="0"
                                    >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 展会图片 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-picture"></i>
                            </div>
                            <div class="section-title">展会图片</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="封面图片" prop="cover_image">
                                    <el-upload
                                            class="cover-upload"
                                            action="/api/upload"
                                            :headers="uploadHeaders"
                                            :on-success="handleCoverImageSuccess"
                                            :on-remove="handleCoverImageRemove"
                                            :before-upload="beforeImageUpload"
                                            :file-list="coverImageList"
                                            list-type="picture-card"
                                            :limit="1"
                                    >
                                        <i class="el-icon-plus"></i>
                                        <div slot="tip" class="el-upload__tip">建议尺寸 800x400px，支持 JPG/PNG 格式，大小不超过 2MB</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="展会图集" prop="gallery_images">
                                    <el-upload
                                            class="gallery-upload"
                                            action="/api/upload"
                                            :headers="uploadHeaders"
                                            :on-success="handleGalleryImageSuccess"
                                            :on-remove="handleGalleryImageRemove"
                                            :before-upload="beforeImageUpload"
                                            :file-list="galleryImageList"
                                            list-type="picture-card"
                                            :limit="10"
                                            multiple
                                    >
                                        <i class="el-icon-plus"></i>
                                        <div slot="tip" class="el-upload__tip">最多上传10张图片，每张不超过2MB</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 详细信息 -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <i class="el-icon-document"></i>
                            </div>
                            <div class="section-title">详细信息</div>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="展会亮点" prop="highlights">
                                    <el-input
                                            v-model="form.highlights"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入展会亮点特色"
                                            maxlength="300"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="参展范围" prop="exhibition_scope">
                                    <el-input
                                            v-model="form.exhibition_scope"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入参展范围"
                                            maxlength="500"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="24">
                                <el-form-item label="注意事项" prop="notes">
                                    <el-input
                                            v-model="form.notes"
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入注意事项"
                                            maxlength="300"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 操作按钮 -->
                    <div class="form-actions">
                        <el-button
                                size="mini"
                                @click="goBack"
                                class="cancel-btn"
                        >
                            <i class="el-icon-close"></i>取消
                        </el-button>
                        <el-button
                                size="mini"
                                type="primary"
                                :loading="loading"
                                @click="submitForm"
                                class="submit-btn"
                        >
                            <i class="el-icon-check"></i>{{ isEdit ? '更新展会' : '保存展会' }}
                        </el-button>
                        <el-button
                                size="mini"
                                @click="resetForm"
                                class="reset-btn"
                        >
                            <i class="el-icon-refresh"></i>重置
                        </el-button>
                    </div>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "expoForm",
        data() {
            // 结束时间验证规则
            const validateEndTime = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请选择结束时间'));
                } else if (this.form.start_time && value <= this.form.start_time) {
                    callback(new Error('结束时间必须晚于开始时间'));
                } else {
                    callback();
                }
            };

            return {
                loading: false,
                isEdit: false,
                exhibitionId: null,

                // 表单数据
                form: {
                    title: '',
                    category_id: '',
                    status: 0,
                    scale: '',
                    description: '',
                    start_time: '',
                    end_time: '',
                    setup_start_time: '',
                    teardown_end_time: '',
                    venue_id: '',
                    expected_visitors: 0,
                    address: '',
                    total_booths: 0,
                    standard_price: '',
                    custom_price: '',
                    cover_image: '',
                    gallery_images: [],
                    highlights: '',
                    exhibition_scope: '',
                    notes: ''
                },

                // 表单验证规则
                rules: {
                    title: [
                        { required: true, message: '请输入展会名称', trigger: 'blur' },
                        { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                    ],
                    category_id: [
                        { required: true, message: '请选择展会分类', trigger: 'change' }
                    ],
                    start_time: [
                        { required: true, message: '请选择开始时间', trigger: 'change' }
                    ],
                    end_time: [
                        { required: true, validator: validateEndTime, trigger: 'change' }
                    ],
                    venue_id: [
                        { required: true, message: '请选择展馆', trigger: 'change' }
                    ],
                    total_booths: [
                        { required: true, message: '请输入总展位数', trigger: 'blur' }
                    ],
                    standard_price: [
                        { required: true, message: '请输入标准展位价格', trigger: 'blur' }
                    ]
                },

                // 分类列表
                categoryList: [
                    { id: 1, name: '工业展会' },
                    { id: 2, name: '消费品展会' },
                    { id: 3, name: '科技展会' },
                    { id: 4, name: '文化展会' },
                    { id: 5, name: '农业展会' }
                ],

                // 展馆列表
                venueList: [
                    { id: 1, title: '国家会展中心' },
                    { id: 2, title: '上海新国际博览中心' },
                    { id: 3, title: '广州国际会展中心' },
                    { id: 4, title: '深圳会展中心' },
                    { id: 5, title: '北京国家会议中心' }
                ],

                // 上传相关
                uploadHeaders: {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
                coverImageList: [],
                galleryImageList: [],

                // 日期选择器配置
                startDatePickerOptions: {
                    disabledDate: (time) => {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                endDatePickerOptions: {
                    disabledDate: (time) => {
                        if (this.form.start_time) {
                            return time.getTime() < this.form.start_time;
                        }
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            };
        },
        created() {
            // 判断是编辑模式还是新增模式
            this.exhibitionId = this.$route.query.id;
            this.isEdit = !!this.exhibitionId;

            // 初始化数据
            this.getCategoryList();
            this.getVenueList();

            // 如果是编辑模式，获取展会详情
            if (this.isEdit) {
                this.getExhibitionDetail();
            }
        },
        methods: {
            // 获取展会详情
            getExhibitionDetail() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    id: this.exhibitionId
                }

                this.$axios.findExpoOne(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        const data = res.data;
                        // 填充表单数据
                        Object.keys(this.form).forEach(key => {
                            if (data[key] !== undefined && data[key] !== null) {
                                this.form[key] = data[key];
                            }
                        });

                        // 处理时间格式（如果后端返回的是时间戳）
                        if (this.form.start_time && typeof this.form.start_time === 'number') {
                            this.form.start_time = this.form.start_time * 1000;
                        }
                        if (this.form.end_time && typeof this.form.end_time === 'number') {
                            this.form.end_time = this.form.end_time * 1000;
                        }
                        if (this.form.setup_start_time && typeof this.form.setup_start_time === 'number') {
                            this.form.setup_start_time = this.form.setup_start_time * 1000;
                        }
                        if (this.form.teardown_end_time && typeof this.form.teardown_end_time === 'number') {
                            this.form.teardown_end_time = this.form.teardown_end_time * 1000;
                        }

                        // 处理图片
                        if (this.form.cover_image) {
                            this.coverImageList = [{
                                name: '封面图片',
                                url: this.form.cover_image
                            }];
                        }

                        if (this.form.gallery_images && this.form.gallery_images.length > 0) {
                            this.galleryImageList = this.form.gallery_images.map((url, index) => ({
                                name: `展会图片${index + 1}`,
                                url: url
                            }));
                        }
                    } else {
                        this.$message.error(res.msg || '获取展会详情失败');
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error('获取展会详情失败');
                })
            },

            // 获取分类列表
            getCategoryList() {
                // const param = {
                //     company_id: sessionStorage.getItem('company_id'),
                //     access_token: sessionStorage.getItem('token')
                // }

                // 这里应该调用实际的API
                // this.$axios.categoryList(param).then(res => {
                //   if (res.code == 200) {
                //     this.categoryList = res.data.data || [];
                //   }
                // })
            },

            // 获取展馆列表
            getVenueList() {
                // const param = {
                //     company_id: sessionStorage.getItem('company_id'),
                //     access_token: sessionStorage.getItem('token')
                // }

                // 这里应该调用实际的API
                // this.$axios.venueList(param).then(res => {
                //   if (res.code == 200) {
                //     this.venueList = res.data.data || [];
                //   }
                // })
            },

            // 处理展馆选择变化
            handleVenueChange(venueId) {
                if (venueId) {
                    const venue = this.venueList.find(item => item.id === venueId);
                    if (venue && !this.form.address) {
                        // 可以自动填充展馆地址
                        // this.form.address = venue.address;
                    }
                }
            },

            // 图片上传前的验证
            beforeImageUpload(file) {
                const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPGorPNG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isJPGorPNG && isLt2M;
            },

            // 封面图片上传成功
            handleCoverImageSuccess(response) {
                if (response.code === 200) {
                    this.form.cover_image = response.data.url;
                    this.$message.success('封面图片上传成功');
                } else {
                    this.$message.error(response.msg || '上传失败');
                }
            },

            // 移除封面图片
            handleCoverImageRemove() {
                this.form.cover_image = '';
                this.coverImageList = [];
            },

            // 图集图片上传成功
            handleGalleryImageSuccess(response) {
                if (response.code === 200) {
                    this.form.gallery_images.push(response.data.url);
                    this.$message.success('图片上传成功');
                } else {
                    this.$message.error(response.msg || '上传失败');
                }
            },

            // 移除图集图片
            handleGalleryImageRemove(file) {
                const url = file.url || file.response.data.url;
                this.form.gallery_images = this.form.gallery_images.filter(item => item !== url);
                this.galleryImageList = this.galleryImageList.filter(item => item.url !== url);
            },

            // 提交表单
            submitForm() {
                this.$refs.exhibitionForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;

                        // 准备提交数据
                        const submitData = {
                            ...this.form,
                            company_id: sessionStorage.getItem('company_id'),
                            access_token: sessionStorage.getItem('token'),
                            operator_id: sessionStorage.getItem('user_id')
                        };

                        // 转换时间格式
                        if (submitData.start_time) {
                            submitData.start_time = Math.floor(submitData.start_time / 1000);
                        }
                        if (submitData.end_time) {
                            submitData.end_time = Math.floor(submitData.end_time / 1000);
                        }
                        if (submitData.setup_start_time) {
                            submitData.setup_start_time = Math.floor(submitData.setup_start_time / 1000);
                        }
                        if (submitData.teardown_end_time) {
                            submitData.teardown_end_time = Math.floor(submitData.teardown_end_time / 1000);
                        }

                        let apiCall;
                        if (this.isEdit) {
                            // 编辑模式，添加ID
                            submitData.id = this.exhibitionId;
                            apiCall = this.$axios.expoInfoUpdate(submitData);
                        } else {
                            // 新增模式
                            apiCall = this.$axios.expoInfoSave(submitData);
                        }

                        apiCall.then(res => {
                            this.loading = false;
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.$router.push('/expoList');
                            } else {
                                this.$message.error(res.msg || '保存失败');
                            }
                        }).catch(error => {
                            this.loading = false;
                            console.log(error);
                            this.$message.error('保存失败，请稍后重试');
                        });

                    } else {
                        this.$message.warning('请完善表单信息');
                        return false;
                    }
                });
            },

            // 重置表单
            resetForm() {
                if (this.isEdit) {
                    // 编辑模式下重置为原始数据
                    this.getExhibitionDetail();
                } else {
                    // 新增模式下清空表单
                    this.$refs.exhibitionForm.resetFields();
                    this.coverImageList = [];
                    this.galleryImageList = [];
                    this.form.gallery_images = [];
                }
            },

            // 返回列表
            goBack() {
                this.$router.push('/exhibitionList');
            }
        }
    };
</script>

<style scoped>
    .exhibition-add-container {
        padding: 20px;
        background: linear-gradient(135deg, #f5f7fa 0%, #e4efe9 100%);
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 12px;
        border: none;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 24px;
        border-bottom: 1px solid #f0f2f5;
        margin-bottom: 0;
        background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%);
        border-radius: 12px 12px 0 0;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
    }

    .header-title i {
        margin-right: 10px;
        color: #409EFF;
        font-size: 22px;
    }

    .form-container {
        padding: 0 24px 24px;
        max-width: 1200px;
        margin: 0 auto;
    }

    .form-section {
        margin-bottom: 32px;
        padding: 24px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e8e8e8;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
    }

    .form-section::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(180deg, #409EFF 0%, #67C23A 100%);
        opacity: 0.8;
    }

    .form-section:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    }

    .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid #f0f2f5;
    }

    .section-icon {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        color: white;
        font-size: 18px;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
    }

    /* 表单元素美化 */
    ::v-deep .el-form-item__label {
        font-weight: 500;
        color: #606266;
    }

    ::v-deep .el-input__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
    }

    ::v-deep .el-input__inner:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }

    ::v-deep .el-textarea__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
    }

    ::v-deep .el-textarea__inner:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }

    ::v-deep .el-select .el-input__inner {
        border-radius: 8px;
    }

    ::v-deep .el-date-editor .el-input__inner {
        border-radius: 8px;
    }

    /* 上传组件美化 */
    .cover-upload, .gallery-upload {
        width: 100%;
    }

    ::v-deep .el-upload--picture-card {
        border: 2px dashed #dcdfe6;
        border-radius: 8px;
        background-color: #fafafa;
        transition: all 0.3s ease;
    }

    ::v-deep .el-upload--picture-card:hover {
        border-color: #409EFF;
        background-color: #f0f7ff;
    }

    ::v-deep .el-upload-list--picture-card .el-upload-list__item {
        border-radius: 8px;
        border: 1px solid #e8e8e8;
    }

    /* 操作按钮区域 */
    .form-actions {
        text-align: center;
        padding: 32px 0 16px;
        margin-top: 24px;
        border-top: 1px solid #f0f2f5;
    }

    .cancel-btn {
        border-radius: 6px;
        padding: 9px 20px;
        border: 1px solid #dcdfe6;
        background: #ffffff;
        color: #606266;
        transition: all 0.3s ease;
    }

    .cancel-btn:hover {
        border-color: #409EFF;
        color: #409EFF;
        background: #f0f7ff;
    }

    .submit-btn {
        border-radius: 6px;
        padding: 9px 24px;
        background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
        border: none;
        color: white;
        transition: all 0.3s ease;
        box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
    }

    .submit-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    }

    .reset-btn {
        border-radius: 6px;
        padding: 9px 20px;
        border: 1px solid #e6a23c;
        background: #fdf6ec;
        color: #e6a23c;
        transition: all 0.3s ease;
    }

    .reset-btn:hover {
        background: #e6a23c;
        color: white;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .exhibition-add-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
            padding: 16px;
        }

        .header-actions {
            margin-top: 10px;
            width: 100%;
            text-align: right;
        }

        .form-container {
            padding: 0 16px 16px;
        }

        .form-section {
            padding: 16px;
            margin-bottom: 20px;
        }

        .section-header {
            margin-bottom: 16px;
        }

        .form-actions {
            padding: 24px 0 8px;
        }

        .form-actions .el-button {
            margin-bottom: 8px;
            width: 100%;
        }
    }

    /* 动画效果 */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .form-section {
        animation: fadeInUp 0.5s ease forwards;
    }

    .form-section:nth-child(1) { animation-delay: 0.1s; }
    .form-section:nth-child(2) { animation-delay: 0.2s; }
    .form-section:nth-child(3) { animation-delay: 0.3s; }
    .form-section:nth-child(4) { animation-delay: 0.4s; }
    .form-section:nth-child(5) { animation-delay: 0.5s; }
    .form-section:nth-child(6) { animation-delay: 0.6s; }
</style>
